import { Image as ChakraImage, Box } from "@chakra-ui/react";
import OptimizedImage from "../shared/OptimizedImage";

// eslint-disable-next-line jsx-a11y/alt-text
const BlogImage = ({ src, ...rest }) => {
  return (
    <Box
      w="100%"
      pos="relative"
      sx={{
        aspectRatio: "16 / 9",
      }}
    >
      <OptimizedImage src={src} objectFit="cover" layout="fill" {...rest} />
    </Box>
  );
};

export default BlogImage;
